import axios from "../axios";
import webaxios from "axios";

export default {
    getUserPermissions(data) {
        return axios.get('/user-permissions', data)
    },
    getUser() {
        return axios.get('/user')
    },
    logUser() {
        return webaxios.get('/login-user')
    },
    getTierInfo() {
        return axios.get('/tier')
    }
}